import {
  Backdrop,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import classes from './AddFile.module.css';
import {
  API_STATUS_PROBLEM,
  MAX_UPLOAD_FILES_COUNT,
  MAX_UPLOAD_FILES_SIZE,
} from '../../constant/constants';
import { IFileUpload } from '../../interface/IFileUpload';
import { IAlertProps } from '../../interface/IAlertProps';
import { getDefaultAlertProps } from '../../utils/utils';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { apiUploadFile } from '../../service/apiUloadFile';
import { IApiResult } from '../../interface/IApiResult';
import { ProgressBox } from '../progress/ProgressBox';
import { WorkspaceDto } from '../../dto/WorkspaceDto';

interface Props {
  idPage: string;
  workspaceDto: WorkspaceDto;
  type: number;
  name: string;
  accept: string;
  icon: any;
  onUpdate: () => any;
  singleFileOnly: boolean;
}

export const AddFile: FunctionComponent<Props> = ({
  idPage,
  workspaceDto,
  type,
  name,
  accept,
  icon,
  onUpdate,
  singleFileOnly,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [shouldShowLoader, setShowLoader] = useState(false);
  const [fileUploads, setFileUploads] = useState<IFileUpload[]>([]);
  const cancelToken = useRef(axios.CancelToken.source());
  const progressRef = useRef(0);
  const [uploadProgress, setUploadProgress] = useState(0);
  const handleProgressUpdate = (event: any) => {
    const progress = (event.loaded / event.total) * 100;
    if (progress > progressRef.current) {
      progressRef.current = progress;
      setUploadProgress(progressRef.current);
    }
  };

  const { section, route } = useParams();

  const cancelCreationOfTweet = () => {
    cancelToken.current.cancel();
    setShowLoader(false);
  };

  const onInputFileChange = async (event: any) => {
    let sizeUploadFiles = 0;
    let sizeUploadAllFiles = 0;
    const dataArray = [];
    for (let i = 0; i < fileUploads.length; i += 1) {
      dataArray.push(fileUploads[i]);
    }
    if (
      event.target.files.length <=
      MAX_UPLOAD_FILES_COUNT - fileUploads.length
    ) {
      if (event.target.files.length > 0) {
        for (let i = 0; i < event.target.files.length; i += 1) {
          if (event.target.files[i].size > sizeUploadFiles) {
            sizeUploadFiles = event.target.files[i].size;
          }
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          sizeUploadAllFiles += event.target.files[i].size;
          const formData = new FormData();
          formData.append('File', event.target.files[i]);
          const dataArrayItem: IFileUpload = {
            data: formData,
            name: event.target.files[i].name,
          };
          dataArray.push(dataArrayItem);
        }
      }
      if (sizeUploadFiles > MAX_UPLOAD_FILES_SIZE) {
        setAlertProps({
          message: 'Превышен размер файла',
          severity: AlertSeverityEnum.info,
        });
        return;
      }
      setFileUploads(dataArray);
      if (dataArray.length !== 0) {
        setShowLoader(true);
        const apiFetches: any[] = [];
        dataArray.forEach((item) => {
          apiFetches.push(
            apiUploadFile(
              type,
              section ?? '',
              route ?? '',
              idPage ?? '',
              item,
              handleProgressUpdate,
              cancelToken.current
            )
          );
        });
        const apiResults: IApiResult[] = await Promise.all(apiFetches);
        for (let i = 0; i < apiResults.length; i += 1) {
          if (!apiResults[i].isSuccess) {
            setAlertProps({
              message: API_STATUS_PROBLEM,
              severity: AlertSeverityEnum.error,
            });
            break;
          }
        }
        setShowLoader(false);
        onUpdate();
      }
    } else {
      setAlertProps({
        message: 'Превышено количество файла',
        severity: AlertSeverityEnum.info,
      });
    }
  };

  useEffect(() => {
    setUploadProgress(0);
    setFileUploads([]);
    progressRef.current = 0;
  }, [workspaceDto]);

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={shouldShowLoader}
        onClick={cancelCreationOfTweet}
      >
        <Stack>
          {fileUploads.length > 0 ? (
            <Stack alignItems="center" spacing={1}>
              <ProgressBox progress={uploadProgress} />
              <Typography variant="caption" component="div" color="inherit">
                Если нажать на экран, то произойдет отмена загрузки
              </Typography>
            </Stack>
          ) : (
            <CircularProgress size={50} color="inherit" />
          )}
        </Stack>
      </Backdrop>
      <IconButton
        size="large"
        sx={{ color: '#128DFF' }}
        className={classes.personalImage}
      >
        <label htmlFor="inputFile">
          <Stack direction="row">
            <input
              id="inputFile"
              name={name}
              type="file"
              accept={accept}
              onChange={onInputFileChange}
              multiple={!singleFileOnly}
            />
            {icon}
          </Stack>
        </label>
      </IconButton>
    </div>
  );
};
